import { lazy, Suspense } from 'react'
import {
  createBrowserRouter,
  RouterProvider,
  Outlet,
  ScrollRestoration,
} from 'react-router-dom'
import Loader from '../components/Loader'
import PrizeGivingForm from '../pages/mobile/PrizeGivingForm'
import { LanguageProvider } from '../context/LanguageContext'
import PrizeGivingInfo from '../pages/mobile/PrizeGivingInfo'

const Header = lazy(() => import('../components/Header'))
const Footer = lazy(() => import('../components/Footer'))
const Home = lazy(() => import('../pages/home/Home'))
const About = lazy(() => import('../pages/About'))
const FAQ = lazy(() => import('../pages/FAQ'))
const ContactUs = lazy(() => import('../pages/ContactUs'))
const TermsOfUSe = lazy(() => import('../pages/TermsOfUses'))
const Privacy = lazy(() => import('../pages/Privacy'))
const PageNotFound = lazy(() => import('../pages/PageNotFound'))
const Guidelines = lazy(() => import('../pages/guidelines/Guidelines'))
const LoginGuidelines = lazy(() =>
  import('../pages/guidelines/LoginGuidelines'),
)
const SecurityGuidelines = lazy(() =>
  import('../pages/guidelines/SecurityGuidelines'),
)
const UploadGuidelines = lazy(() =>
  import('../pages/guidelines/UploadGuidelines'),
)

export function Layout() {
  return (
    <div
      style={{ paddingTop: 90 }}
      className='min-vh-100 overflow-hidden d-flex flex-column '
    >
      <ScrollRestoration />
      <Suspense fallback={<Loader />}>
        <Header />
        <Suspense fallback={<Loader />}>
          <Outlet />
        </Suspense>
        <Footer />
      </Suspense>
    </div>
  )
}

export const router = createBrowserRouter([
  {
    path: '/',
    element: <Layout />,
    children: [
      { index: true, element: <Home /> },
      { path: '/about', element: <About /> },
      { path: '/faq', element: <FAQ /> },
      { path: '/contact', element: <ContactUs /> },
      { path: '/terms-of-uses', element: <TermsOfUSe /> },
      { path: '/guidelines', element: <Guidelines /> },
      { path: '/guidelines/login', element: <LoginGuidelines /> },
      { path: '/guidelines/security', element: <SecurityGuidelines /> },
      { path: '/guidelines/upload', element: <UploadGuidelines /> },
      { path: '/privacy', element: <Privacy /> },
      { path: '*', element: <PageNotFound /> },
    ],
  },
  { path: '/prize-form', element: <PrizeGivingForm /> },
  { path: '/prize-info', element: <PrizeGivingInfo /> },
  { path: '/prize-success', element: <PrizeGivingForm isSuccess /> },

  // { path: '/guidelines', element: <Guidelines /> },
  // { path: '/guidelines/login', element: <LoginGuidelines /> },
  // { path: '/guidelines/security', element: <SecurityGuidelines /> },
  // { path: '/guidelines/upload', element: <UploadGuidelines /> },
])

const RoutersList = () => (
  <LanguageProvider>
    <RouterProvider router={router} />
  </LanguageProvider>
)

export default RoutersList
